import * as React from "react";
import { UitkSheet } from "uitk-react-sheet";
import { UitkFigure, UitkImage } from "uitk-react-images";

export interface MapPoiSheetProps {
  title?: string;
  distance?: string;
  photoUrl?: string;
  description?: string;
  isVisible?: boolean;
}

export const MapPoiSheet: React.FC<MapPoiSheetProps> = props => {
  const { title, photoUrl, description, isVisible } = props;

  if (!title || !isVisible) {
    return null;
  }

  return (
    <UitkSheet className="uitk-grid MapHotelCard" isVisible={isVisible}>
      <MapSheetImage photoUrl={photoUrl} photoAlt={title} />
      <div className="uitk-cell all-cell-fill all-cell-1-2 all-y-padding-three all-x-padding-three">
        <div className="uitk-grid">
          <div className="uitk-cell uitk-type-400 uitk-type-bold">{title}</div>
          {!!description && (
            <div className="uitk-cell all-t-padding-half all-b-padding-one">{description}</div>
          )}
        </div>
      </div>
    </UitkSheet>
  );
};

interface MapSheetImageModel {
  photoUrl?: string;
  photoAlt?: string;
}

export const MapSheetImage = ({ photoUrl, photoAlt }: MapSheetImageModel) => {
  if (!photoUrl) {
    return null;
  }

  return (
    <div className="uitk-cell all-cell-1-4">
      <UitkFigure className="all-image-fit-cover">
        <UitkImage src={photoUrl} alt={photoAlt} placeholderImage={true} />
      </UitkFigure>
    </div>
  );
};

export default MapPoiSheet;
